import styles from "./offCanvaDesign.module.css";
import { FaTimes } from "react-icons/fa";

export default function OffCanvaDesign({ open, onClose, children }) {
  return (
    <div className={`${styles.wrapper} ${open ? styles.show : ""}`}>
      <div className={styles.backdrop} onClick={onClose} />

      <div className={styles.panel}>
        <button className={styles.close} onClick={onClose}>
          <FaTimes />
        </button>

        {children}
      </div>
    </div>
  );
}
